
export const styleClasses = {
  formal: {
    border: "border-amber-200",
    gradient: "from-amber-100 via-yellow-100 to-amber-100",
    pattern: "bg-[#F6F6F7]",
    text: "text-gray-800",
    accent: "text-amber-600",
    titleFont: "font-serif",
    contentFont: "font-sans",
    layout: "space-y-6",
    titleSize: "text-3xl",
    nameSize: "text-4xl",
    subtitleSize: "text-xl",
  },
  fun: {
    border: "border-pink-300",
    gradient: "from-orange-300 via-pink-300 to-purple-300",
    pattern: "bg-[#FDE1D3]",
    text: "text-pink-800",
    accent: "text-pink-600",
    titleFont: "font-display",
    contentFont: "font-sans",
    layout: "space-y-8",
    titleSize: "text-4xl",
    nameSize: "text-5xl",
    subtitleSize: "text-2xl",
  },
  motivational: {
    border: "border-blue-300",
    gradient: "from-blue-400 via-indigo-300 to-purple-400",
    pattern: "bg-[#D3E4FD]",
    text: "text-indigo-900",
    accent: "text-blue-700",
    titleFont: "font-bold",
    contentFont: "font-medium",
    layout: "space-y-6",
    titleSize: "text-4xl",
    nameSize: "text-5xl",
    subtitleSize: "text-2xl",
  },
  elegant: {
    border: "border-purple-300",
    gradient: "from-purple-200 via-pink-200 to-purple-200",
    pattern: "bg-[#E5DEFF]",
    text: "text-purple-900",
    accent: "text-purple-700",
    titleFont: "font-signature",
    contentFont: "font-serif",
    layout: "space-y-4",
    titleSize: "text-3xl",
    nameSize: "text-4xl",
    subtitleSize: "text-xl",
  },
  modern: {
    border: "border-slate-200",
    gradient: "from-slate-100 via-gray-100 to-slate-100",
    pattern: "bg-[#F1F1F1]",
    text: "text-slate-800",
    accent: "text-slate-600",
    titleFont: "font-sans tracking-tight",
    contentFont: "font-light",
    layout: "space-y-8",
    titleSize: "text-4xl",
    nameSize: "text-6xl",
    subtitleSize: "text-2xl",
  },
  kids: {
    border: "border-green-300",
    gradient: "from-yellow-200 via-green-200 to-blue-200",
    pattern: "bg-[#F2FCE2]",
    text: "text-green-800",
    accent: "text-green-600",
    titleFont: "font-display",
    contentFont: "font-display",
    layout: "space-y-8",
    titleSize: "text-4xl",
    nameSize: "text-5xl",
    subtitleSize: "text-2xl",
  },
  academic: {
    border: "border-red-200",
    gradient: "from-red-100 via-amber-100 to-red-100",
    pattern: "bg-[#FFFFFF]",
    text: "text-red-900",
    accent: "text-red-700",
    titleFont: "font-serif",
    contentFont: "font-serif",
    layout: "space-y-6",
    titleSize: "text-3xl",
    nameSize: "text-4xl",
    subtitleSize: "text-xl",
  },
  achievement: {
    border: "border-teal-300",
    gradient: "from-emerald-200 via-teal-200 to-cyan-200",
    pattern: "bg-[#E5DEFF]",
    text: "text-teal-900",
    accent: "text-teal-700",
    titleFont: "font-bold tracking-wide",
    contentFont: "font-medium",
    layout: "space-y-8",
    titleSize: "text-4xl",
    nameSize: "text-5xl",
    subtitleSize: "text-2xl",
  },
};

export type CertificateStyle = keyof typeof styleClasses;
